import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { clearfix, responsiveImage, toVw, toVwMobile, toVwTablet } from '../utils/styles';
import Media from './Media';
import mq from '@/utils/media-queries';

const Wrapper = styled.div``;

const Main = styled(Media)`
  ${responsiveImage};
  margin-bottom: ${toVw(72)};
  width: 100%;

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(51)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(48)};
  `)};
`;

const COL_GAP_DESKTOP = 18;
const COL_GAP_TABLET = 13;

const Row = styled.div`
  ${clearfix};
  margin: 0 -${toVw(COL_GAP_DESKTOP)};

  ${mq.tablet(css`
    margin: 0 -${toVwTablet(COL_GAP_TABLET)};
  `)};

  ${mq.mobile(css`
    margin: 0;
  `)};
`;

const Col = styled.div`
  padding: 0 ${toVw(COL_GAP_DESKTOP)};
  float: left;
  width: 50%;
  box-sizing: border-box;

  ${mq.tablet(css`
    padding: 0 ${toVwTablet(COL_GAP_TABLET)};
  `)};

  ${mq.mobile(css`
    padding: 0;
    float: none;
    width: 100%;
    margin-bottom: ${toVwMobile(48)};

    &:last-child {
      margin-bottom: 0;
    }
  `)};
`;

const Thumb = styled(Media)`
  ${responsiveImage};
  width: 100%;
`;

const Triplet = ({ main, thumbs, ...rest }) => (
  <Wrapper {...rest}>
    {main && <Main {...main.media} />}
    <Row>
      {thumbs &&
        thumbs.map((thumb, index) => (
          <Col key={index}>
            <Thumb {...thumb.media} showBackground />
          </Col>
        ))}
    </Row>
  </Wrapper>
);

Triplet.propTypes = {
  main: PropTypes.object.isRequired,
  thumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Triplet;



// WEBPACK FOOTER //
// ./src/components/Triplet.js